import React from 'react';
import { IconType } from 'react-icons';

export interface ReactIconProps {
  IconComponent: IconType;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  onClickCapture?: React.MouseEventHandler<HTMLDivElement>;
  size?: number;
  style?: React.CSSProperties;
  title?: string;
  className?: string;
}

/**
 * React Icon wrapper component to replace the old IconFont component
 * Uses React Icons instead of custom iconfont
 */
export function ReactIcon(props: ReactIconProps) {
  const {
    IconComponent,
    onClick,
    onClickCapture,
    size,
    style,
    title,
    className,
    ...rest
  } = props;

  // Extract fontSize and convert to number if needed
  const iconSize =
    size ||
    (() => {
      if (!style) return 16;
      const fontSize = (style as any).fontSize;
      if (typeof fontSize === 'number') return fontSize;
      if (typeof fontSize === 'string') {
        const parsed = parseInt(fontSize);
        return isNaN(parsed) ? 16 : parsed;
      }
      return 16;
    })();

  return (
    <div
      title={title}
      onClick={onClick}
      onClickCapture={onClickCapture}
      className={className}
      style={{
        pointerEvents: 'auto',
        color: 'inherit',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
      {...rest}
    >
      {React.createElement(IconComponent as React.ComponentType<any>, {
        size: iconSize,
        style: { color: 'inherit' },
      })}
    </div>
  );
}
